import { coursesSearchValidator } from "@/validators/courses";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

export const Route = createFileRoute("/_app/courses/")({
  validateSearch: zodValidator(coursesSearchValidator),
  loaderDeps: (search) => search, 
});
